import React from "react";
import { FaCog, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";

function NavBar() {
  const navigate = useNavigate();
  const logo = require("../img/eaim_logo_only_w.png");

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        backgroundColor: "#373636",
        padding: "10px 20px",
        margin: "20px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#ddd",
        borderRadius: "10px 10px 10px 10px",
      }}
    >
      <div
        style={{
          display: "flex",
          fontStyle: "italic",
          alignItems: "center",
          fontSize: "1rem",
          gap: "1rem",
        }}
      >
        <Image src={logo} width="80" alt="Logo" style={{ marginTop: "-3px" }} />
        <span
          style={{ color: "#ccc", fontSize: "1.1rem", letterSpacing: "0.5px" }}
        >
          <b>P</b>erformance <b>M</b>anagement <b>A</b>nalysis and <b>R</b>eview
        </span>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          fontSize: "0.9rem",
        }}
      >
        <span className="small" style={{ color: "#ccc" }}>
          {(() => {
            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = now.getFullYear();
            const hours = now.getHours();
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const ampm = hours >= 12 ? "PM" : "AM";
            const hourFormatted = String(hours).padStart(2, "0");
            const weekday = now.toLocaleDateString("en-US", {
              weekday: "long",
            });

            return `${day}-${month}-${year}, ${hourFormatted}:${minutes} ${ampm} (${weekday})`;
          })()}
        </span>
        <FaCog style={{ cursor: "pointer", color: "#fff" }} size={25} />
        <FaSignOutAlt
          style={{ cursor: "pointer", color: "#fff" }}
          size={25}
          onClick={handleLogout}
        />
      </div>
    </div>
  );
}

export default NavBar;
